/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
// import BackButton from '@components/navbar/BackButton';
// import ActionButton from '@components/navbar/ActionButton';

import TargetSettingScreen from '@/screens/setting/target-setting/TargetSettingScreen';
import TargetSettingUploadScreen from '@/screens/setting/target-setting/TargetSettingUploadScreen';
import TargetSettingApprovalScreen from '@/screens/setting/target-setting/TargetSettingApprovalScreen';
// import BudgetPocketDetailScreen from '@/screens/setting/budget-pocket/BudgetPocketDetailScreen';
// import BudgetPocketFormScreen from '@/screens/setting/budget-pocket/BudgetPocketFormScreen';

const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const TargetSettingNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="TargetSettingScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () =>
          isWeb ? <NotificationSettingButton {...props} /> : false,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="TargetSettingScreen"
        component={TargetSettingScreen}
        options={() => ({
          title: setTitleHeader('Target Setting'),
        })}
      />
      <Stack.Screen
        name="TargetSettingUploadScreen"
        component={TargetSettingUploadScreen}
        options={(props) => ({
          title: setTitleHeader(props?.route?.params?.title),
        })}
      />
      <Stack.Screen
        name="TargetSettingApprovalScreen"
        component={TargetSettingApprovalScreen}
        options={(props) => ({
          title: setTitleHeader(props?.route?.params?.title),
        })}
      />
    </Stack.Navigator>
  );
};

export default TargetSettingNavigator;
